import { getIsCountryCompliant } from '@src/modules/global-state/locale-config.browser'
import { removeAndSetNewCookies } from '@src/utils/auth.utils'
import { pick } from '@src/utils/functions/utils'

import { EMPTY_OBJECT } from '../../constants/app'
import { getIsNativeViewClient } from '../../helpers/getIsNativeViewClient'
import { ANALYTIC_COOKIES, ANALYTIC_LOCAL_STORAGE_KEYS, PLATFORMS } from '../constants'
import extractQueryParamFromPageLocation from '../extractQueryParamFromPageLocation'
import getUserDevice from '../getUserDevice'
import safeParse from '../safeParse'
import setCookie from '../setCookie'

import { QuinceCrossPlatformAnalyticsMetadata } from './quince-cross-platform-analytics-metadata.types'

export const initAnalyticsCookieFromCrossPlatformData = () => {
  const crossPlatformAnalyticsMetadata = getCrossPlatformAnalyticsMetadata()
  if (crossPlatformAnalyticsMetadata) {
    const appAnalyticsData = pick(crossPlatformAnalyticsMetadata, [
      'sdk_version',
      'user_profile_id',
      'os_name',
      'network_type',
      'active_experiments',
      'model',
      'manufacturer',
      'carrier',
      'app_build_number',
      'app_build_code',
      'zip_code',
      'device_category',
      'os_version',
      'customer_id',
    ])

    // eslint-disable-next-line @quince/no-direct-localstorage
    localStorage.setItem(ANALYTIC_LOCAL_STORAGE_KEYS.APP_ANALYTICS_DATA, JSON.stringify(appAnalyticsData))

    setCookie(ANALYTIC_COOKIES.SESSION_ID, crossPlatformAnalyticsMetadata.session_id)
    setCookie(ANALYTIC_COOKIES.LB_USER_ID, crossPlatformAnalyticsMetadata.lb_user_id)

    // UK (countryCompliant): never persist raw email to a cookie. US/CA unchanged.
    if (crossPlatformAnalyticsMetadata.email && !getIsCountryCompliant()) {
      removeAndSetNewCookies(ANALYTIC_COOKIES.LB_CUSTOMER_EMAIL, crossPlatformAnalyticsMetadata.email)
    }
    if (crossPlatformAnalyticsMetadata.customer_id) {
      removeAndSetNewCookies(ANALYTIC_COOKIES.LB_CUSTOMER_ID, crossPlatformAnalyticsMetadata.customer_id)
    }
  }
}

export const getUtmValues = () => {
  const crossPlatformAnalyticsMetadata = getCrossPlatformAnalyticsMetadata()

  let utmMedium = extractQueryParamFromPageLocation('utm_medium')
  let utmSource = extractQueryParamFromPageLocation('utm_source')
  let utmCampaign = extractQueryParamFromPageLocation('utm_campaign')
  let utmContent = extractQueryParamFromPageLocation('utm_content')
  let utmTerm = extractQueryParamFromPageLocation('utm_term')
  let qclid = extractQueryParamFromPageLocation('qclid')

  if (crossPlatformAnalyticsMetadata) {
    utmMedium = crossPlatformAnalyticsMetadata.utm_medium
    utmSource = crossPlatformAnalyticsMetadata.utm_source
    utmCampaign = crossPlatformAnalyticsMetadata.utm_campaign
    utmContent = crossPlatformAnalyticsMetadata.utm_content
    utmTerm = crossPlatformAnalyticsMetadata.utm_term
    qclid = crossPlatformAnalyticsMetadata.qclid
  }

  return {
    utmMedium,
    utmSource,
    utmCampaign,
    utmContent,
    utmTerm,
    qclid,
  }
}

export const getAppAnalyticsData = () => {
  // eslint-disable-next-line @quince/no-direct-localstorage
  const appAnalyticsDataString = localStorage.getItem(ANALYTIC_LOCAL_STORAGE_KEYS.APP_ANALYTICS_DATA)
  const context = appAnalyticsDataString ? safeParse(appAnalyticsDataString, {}) : EMPTY_OBJECT
  return { context, platform: getPlatform() }
}

const getPlatform = () => {
  return getIsNativeViewClient() ? PLATFORMS.APP : getWebType()
}
const getWebType = () => {
  const userDevice = getUserDevice()
  if (['mobile', 'tablet'].includes(userDevice)) {
    return PLATFORMS.MWEB
  }
  return PLATFORMS.WEB
}

const getCrossPlatformAnalyticsMetadata = () => {
  // eslint-disable-next-line @quince/no-direct-localstorage
  const crossPlatformAnalyticsMetadataString = window.localStorage.getItem('quince_cross_platform_analytics_metadata')
  const crossPlatformAnalyticsMetadata = crossPlatformAnalyticsMetadataString
    ? safeParse<QuinceCrossPlatformAnalyticsMetadata | null>(crossPlatformAnalyticsMetadataString, null)
    : null
  return crossPlatformAnalyticsMetadata
}
